


















import { Component, Vue } from "vue-property-decorator";
import hl from "@/helper/highlight";
import expand from "emmet";

@Component
export default class App extends Vue {
  emmet = "table.table>(thead.head>tr>th*3{Head $})+(tbody.body>tr*5>th*3{$$$})";

  get html() {
    return hl.highlight("html", expand(this.emmet)).value;
  }
}
